/** Joins the truthy class names with spaces. */
export function cx(...classNames) {
    return classNames.filter(Boolean).join(' ');
}

// Undoes the browser's own button and input font styles (Tailwind's preflight
// reset is off; MUI's CssBaseline does not reset controls). The font is
// inherited through arbitrary properties, which outrank font utilities on the
// same element: set the font on the parent instead. Each control still sets
// its own border, background, padding and colour (the browser defaults
// `buttontext`), since two utilities for one property have no reliable order.
export const controlResetClassName = 'm-0 appearance-none [font:inherit] [letter-spacing:inherit] '
    + '[text-transform:inherit]';
